/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleExport } from './APIArticleExport';
import {
    APIArticleExportFromJSON,
    APIArticleExportFromJSONTyped,
    APIArticleExportToJSON,
} from './APIArticleExport';

/**
 * 
 * @export
 * @interface APIPaginatedArticleExportList
 */
export interface APIPaginatedArticleExportList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedArticleExportList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedArticleExportList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedArticleExportList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIArticleExport>}
     * @memberof APIPaginatedArticleExportList
     */
    results: Array<APIArticleExport>;
}

/**
 * Check if a given object implements the APIPaginatedArticleExportList interface.
 */
export function instanceOfAPIPaginatedArticleExportList(value: object): value is APIPaginatedArticleExportList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedArticleExportListFromJSON(json: any): APIPaginatedArticleExportList {
    return APIPaginatedArticleExportListFromJSONTyped(json, false);
}

export function APIPaginatedArticleExportListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedArticleExportList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIArticleExportFromJSON)),
    };
}

export function APIPaginatedArticleExportListToJSON(value?: APIPaginatedArticleExportList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIArticleExportToJSON)),
    };
}

